import Vue from 'vue'




//克隆
export function deepClone(source) {
    if (!source && typeof source !== 'object'||typeof source === 'string') {
      return source;
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
      if (source[keys] && typeof source[keys] === 'object') {
        targetObj[keys] = deepClone(source[keys])
      } else {
        targetObj[keys] = source[keys]
      }
    })
    return targetObj
  }


Vue.prototype.$clone = deepClone;
